(() => {
  const sortSelector = '.facet-filters__field .facet-filters__sort, .mobile-facets__sort .select__select';
  let menuIndex = 0;

  class BanicSortControl {
    constructor(select) {
      this.select = select;
      this.root = select.closest('.select');

      if (!this.root || this.root.classList.contains('banic-sort--enhanced')) return;

      this.root.classList.add('banic-sort', 'banic-sort--enhanced');
      this.select.tabIndex = -1;
      this.select.setAttribute('aria-hidden', 'true');
      this.select.hidden = true;

      this.trigger = document.createElement('button');
      this.trigger.type = 'button';
      this.trigger.className = 'banic-sort__trigger';
      this.trigger.setAttribute('aria-haspopup', 'listbox');
      this.trigger.setAttribute('aria-expanded', 'false');

      this.label = document.createElement('span');
      this.label.className = 'banic-sort__value';

      const chevron = document.createElement('span');
      chevron.className = 'banic-sort__chevron';
      chevron.setAttribute('aria-hidden', 'true');
      this.trigger.append(this.label, chevron);

      this.menu = document.createElement('div');
      this.menu.className = 'banic-sort__menu';
      this.menu.id = `BanicSortMenu-${++menuIndex}`;
      this.menu.setAttribute('role', 'listbox');
      this.menu.hidden = true;
      this.trigger.setAttribute('aria-controls', this.menu.id);

      Array.from(this.select.options).forEach((option, index) => {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'banic-sort__option';
        item.dataset.value = option.value;
        item.dataset.index = index;
        item.setAttribute('role', 'option');
        item.textContent = option.textContent.trim();
        this.menu.append(item);
      });

      this.root.append(this.trigger, this.menu);
      this.root.banicSortControl = this;

      const field = this.root.closest('.facet-filters__field, .mobile-facets__sort');
      const nativeLabel = field?.querySelector(`label[for="${CSS.escape(this.select.id)}"]`);
      this.trigger.id = `BanicSortTrigger-${menuIndex}`;
      this.label.id = `BanicSortValue-${menuIndex}`;
      if (nativeLabel) {
        nativeLabel.id ||= `BanicSortLabel-${menuIndex}`;
        nativeLabel.htmlFor = this.trigger.id;
        this.trigger.setAttribute('aria-labelledby', `${nativeLabel.id} ${this.label.id}`);
      }

      this.trigger.addEventListener('click', () => this.toggle());
      this.trigger.addEventListener('keydown', (event) => this.onTriggerKeydown(event));
      this.menu.addEventListener('click', (event) => this.onOptionClick(event));
      this.menu.addEventListener('keydown', (event) => this.onMenuKeydown(event));
      this.select.addEventListener('input', () => this.sync());
      this.select.addEventListener('change', () => this.sync());
      this.sync();
    }

    get options() {
      return Array.from(this.menu.querySelectorAll('.banic-sort__option'));
    }

    sync() {
      const selected = this.select.options[this.select.selectedIndex];
      if (!selected) return;

      this.label.textContent = selected.textContent.trim();
      this.options.forEach((option) => {
        const isSelected = option.dataset.value === this.select.value;
        option.setAttribute('aria-selected', String(isSelected));
        option.tabIndex = isSelected ? 0 : -1;
      });
    }

    open(focusDirection = 0) {
      document.querySelectorAll('.banic-sort--open').forEach((root) => {
        if (root !== this.root) root.banicSortControl?.close();
      });

      this.menu.hidden = false;
      this.root.classList.add('banic-sort--open');
      this.trigger.setAttribute('aria-expanded', 'true');

      if (focusDirection !== 0) {
        const options = this.options;
        const selectedIndex = options.findIndex((option) => option.getAttribute('aria-selected') === 'true');
        const targetIndex = focusDirection < 0 ? options.length - 1 : Math.max(selectedIndex, 0);
        options[targetIndex]?.focus();
      }
    }

    close(restoreFocus = false) {
      this.menu.hidden = true;
      this.root.classList.remove('banic-sort--open');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.trigger.focus();
    }

    toggle() {
      if (this.menu.hidden) this.open();
      else this.close();
    }

    choose(option) {
      this.select.value = option.dataset.value;
      this.sync();
      this.close(true);
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
    }

    onOptionClick(event) {
      const option = event.target.closest('.banic-sort__option');
      if (option) this.choose(option);
    }

    onTriggerKeydown(event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      this.open(event.key === 'ArrowUp' ? -1 : 1);
    }

    onMenuKeydown(event) {
      const options = this.options;
      const current = event.target.closest('.banic-sort__option');
      if (!current) return;

      const currentIndex = options.indexOf(current);
      let targetIndex = currentIndex;

      if (event.key === 'ArrowDown') targetIndex = (currentIndex + 1) % options.length;
      else if (event.key === 'ArrowUp') targetIndex = (currentIndex - 1 + options.length) % options.length;
      else if (event.key === 'Home') targetIndex = 0;
      else if (event.key === 'End') targetIndex = options.length - 1;
      else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.choose(current);
        return;
      } else if (event.key === 'Escape') {
        event.preventDefault();
        this.close(true);
        return;
      } else if (event.key === 'Tab') {
        this.close();
        return;
      } else {
        return;
      }

      event.preventDefault();
      options[targetIndex]?.focus();
    }
  }

  const enhanceSortControls = (scope = document) => {
    if (scope.matches?.(sortSelector)) new BanicSortControl(scope);
    scope.querySelectorAll?.(sortSelector).forEach((select) => new BanicSortControl(select));
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.banic-sort--open').forEach((root) => {
      if (!root.contains(event.target)) root.banicSortControl?.close();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.banic-sort--open').forEach((root) => root.banicSortControl?.close(true));
  });

  enhanceSortControls();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) enhanceSortControls(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
